import { Button, CircularProgress } from "@mui/material";
import RightArrow from "../Vectors/RightArrow";

const DelendLoginButton = (props) => {
  if (props.loading) {
    return (
      <Button
        disabled={true}
        variant="contained"
        fullWidth
        endIcon={<CircularProgress size="26px" />}
      />
    );
  }

  return (
    <Button
      data-testid="account-delete-submit"
      onClick={props.onClick}
      type="submit"
      disabled={props.disable}
      variant="contained"
      fullWidth
      endIcon={<RightArrow />}
    >
      Entrar
    </Button>
  );
};

export default DelendLoginButton;
